export default __webpack_public_path__ + "media/bundles/Sso/src/components/pages/423/block_icon-93713a6c119c8b4f57c51d3bba0a2ef2.png";